module.exports = __webpack_public_path__ + "img/mark_zhengchang.bc3ba3de.png";